import { use } from 'react';

import { type ClientRuntimeEnvironment } from '@/src/environment';

import { EnvironmentContextObj } from '../context';

/**
 * Returns the {@link ClientRuntimeEnvironment} provided by the {@link EnvironmentProvider}.
 *
 * The value is sourced from the server-injected page environment when the active page is wrapped
 * in a page-context wrapper, and from the fallback `/api/client-environment` request otherwise;
 * consumers are agnostic to which path supplied it and simply observe `isReady` flip once the
 * environment is available.
 */
export const useClientEnvironment = (): ClientRuntimeEnvironment => use(EnvironmentContextObj);
